import React from 'react';
import {Block, Title, Icon, Loader} from '../../../components/components'
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import { useHistory, useRouteMatch } from 'react-router-dom';
import Pagination from "../../../components/tables/Pagination";
import useCustomTable from "../../../components/tables/useCustomTable";
import {TableSearchRow} from "../../../components/tables/TableSearch";
import Table from "../../../components/tables/Table";
import { useGetAudiencesQuery } from "../../../api/audienceApiSlice";

export default function AudiencesList() {
	const { t } = useTranslation();
  const history = useHistory();
  const {
    data: audiences = [],
    isSuccess,
    isError,
    retry
  } = useGetAudiencesQuery()
  const { path } = useRouteMatch();
  const loaderProps = { success: isSuccess, error: isError, refetch: retry }

  const columns = [{
    	Header: 'Name',
    	accessor: 'name',
  	},{
      Header: 'Key',
      accessor: 'key'
    },{
    	Header: 'extract',
    	accessor: 'extract',
    	disableSortBy: true
  	},{
    	Header: 'Created at',
    	accessor: 'created_at',
  	}
  ]

  const newAudience = () => history.push(`/audiences/new`)

  const showAudience = (rowData) => history.push(`/audiences/${rowData.key}`);

  const {
    tableProps,
    paginationProps,
    tableSearchProps
  } = useCustomTable({
    sortable: true,
    paginate: true
  })

	return (
    <>
			<Title main={t("menu.audiences")} >
        <Button variant='primary' onClick={newAudience}>
          <Icon icon='plus' text={t("audience.new")} />
        </Button>
      </Title>
      <TableSearchRow {...tableSearchProps}/>
      <Block className="mb-0">
        <Loader {...loaderProps} >
          <Table data={audiences} columns={columns} onRowClick={showAudience} {...tableProps} />
        </Loader>
     </Block>
      <Pagination {...paginationProps}/>
		</>
	)
}
